import React, { useState, useRef, ReactInstance, useEffect } from 'react'
import Modal from 'react-modal'
import { connect } from 'react-redux'
import { getStore, setStore, keys } from '../../actions/localStorage'
import { getCSCId } from '../../actions/api'
import ReactToPrint from '../ReactToPrint'
import PrintVehicleCard from './PrintSample/VehicleCard'
import PrintSeawayBill from './PrintSample/SeawayBill'
import './devTools.less'
import TestSeaWayBill from './TestSeaWayBill'
import { getReservationByNumberAndDriversBirthday } from '../../actions'
import { AppState } from '../../reducers'

// to test print feature run Chrome in kiosk module, e.g.
// /Applications/Google\ Chrome.app/Contents/MacOS/Google\ Chrome --enable-print-preview --kiosk --kiosk-printing --app=http://localhost:3000/
class EmptyComponent extends React.Component {
  render() {
    return null
  }
}
const customStyles = {
  content: {
    top: '10px',
    left: '10px',
    right: '50%',
    bottom: '50%',
  },
}
const fontOptions = [
  { value: 'Arial', label: 'Arial' },
  { value: 'Calibri', label: 'Calibri' },
  { value: 'GT-Walsheim-Regular', label: 'GT-Walsheim' },
  { value: 'RobotoMono-Regular', label: 'Roboto-Mono' },
]

interface OwnProps {
  onClose: () => void
}

const mapStateToProps = (state: AppState) => ({
  reservation: state.reservation.originReservation,
})

const mapDispatchToProps = {
  getReservation: getReservationByNumberAndDriversBirthday,
}

type StateProps = ReturnType<typeof mapStateToProps>
type DispatchProps = typeof mapDispatchToProps
type Props = StateProps & DispatchProps & OwnProps

const DevTools: React.FC<Props> = ({ onClose, reservation, getReservation }: Props) => {
  const ele: ReactInstance = new EmptyComponent({})
  const [httpMock, setHttpMock] = useState(getStore(keys.HTTP_MOCK))
  const [httpTimeout, setHttpTimeout] = useState(getStore(keys.ADD_HTTP_TIMEOUT))
  const [outOfService, setOutOfService] = useState(getStore(keys.OUT_OF_SERVICE))
  const [isShowSWB, setIsShowSWB] = useState(false)
  const [currentFont, setFont] = useState(fontOptions[0].value)
  const [fontIncreaser, setFontIncreaser] = useState('0')
  const printVehicleCardRef = useRef<any>(null)
  const buttonVehicleCardRef = useRef<HTMLButtonElement | null>(null)
  const onCurrentVehicleCard = () => (printVehicleCardRef.current ? printVehicleCardRef.current : ele)
  const printSeawayBillRef = useRef<any>(null)
  const buttonSeawayBillRef = useRef<HTMLButtonElement | null>(null)
  const onCurrentSeawayBill = () => (printSeawayBillRef.current ? printSeawayBillRef.current : ele)
  const onChangeHttpMock = (e: any) => {
    setHttpMock(e.target.checked)
    setStore(keys.HTTP_MOCK, e.target.checked)
  }
  const addHttpTimeout = (e: any) => {
    setHttpTimeout(e.target.checked)
    setStore(keys.ADD_HTTP_TIMEOUT, e.target.checked)
  }
  const toggleHttpOutOfService = (e: any) => {
    setOutOfService(e.target.checked)
    setStore(keys.OUT_OF_SERVICE, e.target.checked)
  }
  useEffect(() => {
    console.log('current font: ', currentFont)
  }, [currentFont])
  return (
    <Modal ariaHideApp={false} isOpen onRequestClose={onClose} style={customStyles} contentLabel="Dev Tools">
      <div className="dev-tools">
        <div className="dev-CSC">
          ID: <b>{getCSCId()}</b>
        </div>
        <br />
        <div>
          <input type="checkbox" checked={httpMock} onChange={onChangeHttpMock} />
          <span>enable Http mock</span>
        </div>
        <div>
          <input type="checkbox" checked={httpTimeout} onChange={addHttpTimeout} />
          <span>add Http timeout</span>
        </div>
        <div>
          <input type="checkbox" checked={outOfService} onChange={toggleHttpOutOfService} />
          <span>enable Out Of Service</span>
        </div>
        <hr />
        <select value={currentFont} onChange={(event) => setFont(event.target.value)}>
          {fontOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <br />
        <div className="font-size-change">
          <div className="inputs-label">Font increase (+), decrease (-) (pixel)</div>
          <div className="inputs-fields">
            <input
              className="input-increaser"
              type="number"
              value={fontIncreaser}
              pattern="[0-9]*"
              inputMode="numeric"
              onChange={(e) => setFontIncreaser(e.target.value)}
            />
            <input
              className="input-range-increaser"
              type="range"
              min="-10"
              max="10"
              step="1"
              value={fontIncreaser}
              onChange={(e) => setFontIncreaser(e.target.value)}
            />
          </div>
        </div>

        <br />
        <ReactToPrint
          trigger={() => <button ref={buttonSeawayBillRef} className="hidden-button" />}
          content={onCurrentSeawayBill}
          copyStyles
          onAfterPrint={() => {
            console.log('printed SeawayBill')
          }}
        />
        <div ref={printSeawayBillRef} className="print-template">
          <PrintSeawayBill currentFont={currentFont} fontIncreaser={+fontIncreaser} />
        </div>
        <button onClick={() => buttonSeawayBillRef.current && buttonSeawayBillRef.current.click()}>
          Print SeawayBill
        </button>
        <br />
        <ReactToPrint
          trigger={() => <button ref={buttonVehicleCardRef} className="hidden-button" />}
          content={onCurrentVehicleCard}
          copyStyles
          onAfterPrint={() => {
            console.log('printed VehicleCard')
          }}
        />
        <div ref={printVehicleCardRef} className="print-template">
          <PrintVehicleCard currentFont={currentFont} fontIncreaser={+fontIncreaser} />
        </div>
        <button onClick={() => buttonVehicleCardRef.current && buttonVehicleCardRef.current.click()}>
          Print VehicleCard
        </button>
        <br />
        <hr />
        {reservation && (
          <button id="SWB-button" onClick={() => setIsShowSWB(true)}>
            Show SWB
          </button>
        )}
        {!reservation && (
          <button id="SWB-button" onClick={() => getReservation({ resId: 123456789, driverBirthDate: '01.01.1990' })}>
            Get reservation data
          </button>
        )}
        <TestSeaWayBill isShowSWB={isShowSWB} onClose={() => setIsShowSWB(false)} />
      </div>
    </Modal>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(DevTools)
